import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PageDetails {
  page: string;
  time: string;
}

interface SessionLogState {
  pageDetails: PageDetails[];
}

const initialState: SessionLogState = {
  pageDetails: [],
};

export const sessionLogReducer = createSlice({
  name: "sessionLog",
  initialState,
  reducers: {
    pushPage: (state, action: PayloadAction<string>) => {
      state.pageDetails = [
        ...state.pageDetails,
        { page: action.payload, time: new Date().toISOString() },
      ];
    },
    resetPages: (state) => {
      state.pageDetails = [];
    },
  },
});

export const { pushPage, resetPages } = sessionLogReducer.actions;

export default sessionLogReducer.reducer;
